import React, { useState } from "react";
import Note from "./note_creator";
import Engineering from "./engineering_notebook";
import Tasks from "./tasks";
import ClipLoader from 'react-spinners/ClipLoader';  // Import the spinner

function Dashboard( ) {
    const [loading, setLoading] = useState(false);

    return (
        <>
            <div className="flex flex-col text-center m-auto w-min xs:w-[30rem] md:w-[46rem] pt-10">
                {loading && (
                    <div className="fixed  inset-0  bg-white bg-opacity-75 flex justify-center items-center z-10">
                        <ClipLoader color="#ff0000" loading={loading} size={50} />
                    </div>
                )}
                <h1 className="text-4xl sm:text-5xl  ">Dashboard</h1>
                <div className="flex flex-col m-auto ">
                    <div className="flex-col xs:flex-row flex gap-4 justify-center pt-4">
                        <Note  setLoading={setLoading}/>
                        <Engineering setLoading={setLoading}/>
                    </div>
                    <div className="pt-4 ">
                        <Tasks setLoading={setLoading}/>
                    </div>
                </div>
            </div>
        </>
    )
}
export default Dashboard